import { create, StateCreator } from 'zustand';
import { persist, PersistOptions } from 'zustand/middleware';

type ColumnStore = {
  selectedColumns: string[];
  setSelectedColumns: (columns: string[]) => void;
};

type ColumnStorePersist = (
  config: StateCreator<ColumnStore>,
  options: PersistOptions<ColumnStore>
) => StateCreator<ColumnStore>;

const useTicketTableColumnStore = create<ColumnStore>(
  (persist as ColumnStorePersist)(
    (set: (partial: Partial<ColumnStore>) => void) => ({
      selectedColumns: ["displayid", "subject", "ticketStatus", "country", "account", "internalOwner"],
      setSelectedColumns: (columns: string[]) => set({ selectedColumns: columns }),
    }),
    {
      name: 'ticket-index-table-columns',
      onRehydrateStorage: () => (state) => {
        const localStorageData = JSON.parse(localStorage.getItem("ticket-index-table-columns") || "{}");
        if (localStorageData?.state?.selectedColumns?.length === 0) {
          state?.setSelectedColumns(["displayid", "subject"]);
        }
      },
    }
  )
);

export default useTicketTableColumnStore;